import React from 'react'
import { createIcon } from '@chakra-ui/react'

export const FrFlag = createIcon({
  displayName: 'FrFlag',
  viewBox: '0 0 900 600',
  path: [
    <svg height="600" key="flag-fr" width="900">
      <rect fill="#ED2939" height="600" width="900" />
      <rect fill="#fff" height="600" width="600" />
      <rect fill="#002395" height="600" width="300" />
    </svg>,
  ],
})
